export default __webpack_public_path__ + "static/kuru-neden-e74950d336e71b61564c72898d961e54.png";